import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col, Drawer } from 'antd';
import isEqual from 'lodash/isEqual';

import { pageChanged } from '../../../../../data/redux/page_details/actions';
import * as agentActions from '../../../../../data/redux/member_details/actions';

import { APP_PAGES } from '../../../../../data/config/constants';
import { showMessage } from '../../../../../data/config/utils';
import { IMG_ERROR, IMG_EMPTY } from '../../../../../data/assets/img';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import CustomHeader from '../../../../../components/customheader';
import ModalFooter from '../../../../../components/modalfooter';
import CannedResponseForm from './components/cannedresponseform';
import CannedResponseCard from './components/cannedresponsecard';
import ShowMessage from '../../../../../components/showmessage';

class CannedResponses extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filtered_canned_responses: props.member_details.canned_responses,
      search_text: "",
      active_canned_response: {},
      drawer_data: {
        title: "",
        show_add_canned_response: false,
        show_edit_canned_response: false,
      },
    };
  }

  componentDidMount() {
    const { member_details, actions, agent_email } = this.props;
    actions.pageChanged(APP_PAGES.CANNED_RESPONSES, APP_PAGES.MEMBERS);
    if (member_details.canned_responses.length === 0) {
      if (agent_email) {
        actions.getAgentCannedResponses({ email: agent_email });
      } else {
        showMessage('error', 'email id is missing');
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { member_details } = this.props;
    const { search_text } = this.state;

    if (!isEqual(nextProps.member_details.canned_responses, member_details.canned_responses)) {
      const canned_responses = [...nextProps.member_details.canned_responses];
      if (search_text.trim().length !== 0) {
        this.setState({
          filtered_canned_responses: this.filterBySearchText(search_text, canned_responses)
        });
      } else {
        this.setState({
          filtered_canned_responses: canned_responses
        });
      }
    }
  }

  filterBySearchText = (text, array) => {
    return array.filter(item => {
      return (item.shortcut && item.shortcut !== undefined && item.shortcut.toLowerCase().indexOf(text.toLowerCase()) !== -1);
    });
  };

  handleCannedResponseSearch = event => {
    const search_text = event.target.value;
    const { member_details } = this.props;
    this.setState({ search_text });
    if (search_text.trim().length !== 0) {
      this.setState({
        filtered_canned_responses: this.filterBySearchText(search_text, member_details.canned_responses)
      });
    } else {
      this.setState({
        filtered_canned_responses: member_details.canned_responses
      });
    }
  };

  closeDrawer = () => {
    this.setState({
      active_canned_response: {},
      drawer_data: {
        title: "",
        show_add_canned_response: false,
        show_edit_canned_response: false,
      }
    });
  };

  showAddCannedResponse = () => {
    this.setState({
      active_canned_response: {
        messages: [],
        shortcut: "",
        heading: "",
        subHeading: "",
      },
      drawer_data: {
        title: "Add Canned Response",
        show_add_canned_response: true,
        show_edit_canned_response: false,
      }
    });
  };

  editCannedResponse = canned_response => {
    this.setState({
      active_canned_response: canned_response,
      drawer_data: {
        title: "Edit Canned Response",
        show_add_canned_response: false,
        show_edit_canned_response: true,
      }
    });
  };

  deleteCannedResponse = canned_response => {
    const { actions } = this.props;
    const payload = {
      _id: canned_response._id
    };
    actions.deleteCannedResponse(payload);
  };

  onChangeActiveCannedResponse = (key, value) => {
    this.setState({
      active_canned_response: {
        ...this.state.active_canned_response,
        [key]: value
      },
    });
  };

  addNewActiveCannedMessage = message => {
    const { active_canned_response } = this.state;
    this.setState({
      active_canned_response: {
        ...active_canned_response,
        messages: [message, ...active_canned_response.messages]
      },
    });
  };

  onClickDeleteMessage = index => {
    const { active_canned_response } = this.state;
    this.setState({
      active_canned_response: {
        ...active_canned_response,
        messages: [...active_canned_response.messages.slice(0, index), ...active_canned_response.messages.slice(index + 1)]
      },
    });
  };

  handleCannedResponseFormSubmit = () => {
    const { drawer_data, active_canned_response } = this.state;
    const { actions } = this.props;
    if (drawer_data.show_add_canned_response) {
      actions.createCannedResponse(active_canned_response, this.closeDrawer);
    } else if (drawer_data.show_edit_canned_response) {
      actions.updateCannedResponse(active_canned_response, this.closeDrawer);
    }
  };

  renderCannedResponseCards = () => {
    const { filtered_canned_responses } = this.state;
    if (filtered_canned_responses.length > 0) {
      return (
        <Row gutter={10}>
          <Col xs={24} sm={12}>
            {
              filtered_canned_responses.map((canned_response, index) => {
                if (index % 2 === 0)
                  return (
                    <CannedResponseCard key={index} canned_response={canned_response} onCannedMessageEdit={this.editCannedResponse} onCannedMessageDelete={this.deleteCannedResponse} />
                  );
              })
            }
          </Col>
          <Col xs={24} sm={12}>
            {
              filtered_canned_responses.map((canned_response, index) => {
                if (index % 2 !== 0)
                  return (
                    <CannedResponseCard key={index} canned_response={canned_response} onCannedMessageEdit={this.editCannedResponse} onCannedMessageDelete={this.deleteCannedResponse} />
                  );
              })
            }
          </Col>
        </Row>
      );
    }
    return (
      <ShowMessage img_src={IMG_EMPTY} height={150} width={150} title="Empty list" message="There is no any canned responses. please click on add shortcuts button to add canned responses" />
    );
  };

  render() {
    const { screen_width, member_details } = this.props;
    const { drawer_data, active_canned_response } = this.state;

    if (member_details.loaders.canned_responses_loading && !member_details.loaders.canned_responses_loaded) {
      return (
        <div className="ori-lr-pad-10">
          <PageHeaderLoader bottom_bordered />
          <div className="ori-tb-pad-10">
            <CardRowTableLoader />
          </div>
        </div>
      )
    } else if (!member_details.loaders.canned_responses_loading && member_details.loaders.canned_responses_loaded) {
      return (
        <div className="ori-lr-pad-10">
          <CustomHeader title="Canned Responses" search_placeholder="search shortcut" first_button_type="primary" first_button_text="+ Add shortcut" onClickFirstButton={this.showAddCannedResponse} onChangeSearch={this.handleCannedResponseSearch} bottom_bordered show_first_button show_search />
          {this.renderCannedResponseCards()}
          <Drawer className="ori-drawer ori-drawer-title-primary ori-drawer-footer-pad ori-drawer-height-without-footer" width={screen_width < 768 ? screen_width : 500} title={drawer_data.title} visible={drawer_data.show_add_canned_response || drawer_data.show_edit_canned_response} placement="right" maskClosable={false} onClose={this.closeDrawer}>
            {
              (drawer_data.show_add_canned_response || drawer_data.show_edit_canned_response) &&
              <div className="ori-full-parent-height ori-overflow-y-auto ori-overflow-x-hidden">
                <CannedResponseForm canned_response={active_canned_response} onChange={this.onChangeActiveCannedResponse} addNewMessage={this.addNewActiveCannedMessage} onClickDeleteMessage={this.onClickDeleteMessage} />
                <div className="ori-absolute ori-full-width ori-align-bottom ori-align-left ori-b-pad-5">
                  <ModalFooter button_ok_text={drawer_data.show_add_canned_response ? "create" : "update"} loading={false} handleCancelClick={this.closeDrawer} handleOkClick={this.handleCannedResponseFormSubmit} capsule_button />
                </div>
              </div>
            }
          </Drawer>
        </div>
      );
    } else if (!member_details.loaders.canned_responses_loading && !member_details.loaders.canned_responses_loaded) {
      return (
        <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load admin list. please check your internet connection and reload the page." height={150} width={150} />
      )
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    member_details: state.member_details,
    agent_email: state.admin_details.user_info && state.admin_details.user_info.email ? state.admin_details.user_info.email : null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged }, agentActions), dispatch)
  };
};

CannedResponses.propTypes = {
  screen_width: PropTypes.number,
  member_details: PropTypes.object,
  agent_email: PropTypes.string,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(CannedResponses);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/cannedresponses/index.js